import React, { useState, useEffect, useContext } from "react"
import { getDateInFormat, getAge, isEquitasChannel } from "../services/helperFunctions"
import { JourneyContext } from "../context/journeyContext"
import styled from "styled-components"
import {
  getOTP,
  fetchAllJourneyData,
  verifyDeclarationOtp,
  saveApplication,
  flexiEdgeProposalForm,
  verifyDeclarationOtpV2,
  resumeLinkForSendCaseToCustomer,
  getConfigurationsByType
} from "../../services/apiservice"
import { errorToastr } from "../../services/error-handler"
import { wordCapital } from "../../shared/functions"
import { isIE } from "react-device-detect"
import Select from "react-select"
import { PageContext } from "../context/pageContext"
import ConfirmProceedModal from "./ConfirmProceedModal"
import { triggerSpEnrichment, startSpEnrichmentPolling } from "../../services/equitasSpDetailsService"

const SalesConfidentialReport = (props) => {

  const SelectContainer = styled.div`
display: block;
flex-direction: column;
margin: 18px 0;
position: relative;
box-sizing: border-box;
font-size: 15px;
color: #505050;
float: left;
min-width: 100%;
max-width: 100%;

& > .css-2b097c-container {
  margin-top: -17px;

  & div.css-1pahdxg-control{
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"}  !important;
    background: var(--lumiq-bg) !important;
  }

  & > div {
    border-radius: 0;
    border: 1px solid #929292;
    padding: 1rem 0;
    padding-bottom: 0;
  }
  .css-1uccc91-singleValue{
    color:inherit;
    font-size: 1rem;
  }

  & div.css-yk16xz-control{
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);

    .css-1hb7zxy-IndicatorsContainer > div{
      padding: 0 !important;        
      padding-right: 4px !important;        
    }
  }
  .css-1gtu0rj-indicatorContainer{
    padding: 0 !important;
    padding-right: 4px !important;        

  }
  & > div.css-26l3qy-menu {
    z-index: 500 !important;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background:var(--lumiq-bg)
  }

  & > div {
    box-shadow: none !important;
    border: 1px solid #929292;
  }
  & .css-1okebmr-indicatorSeparator {
    background: transparent;
  }
}

& > label {
  margin-left: 8px;
  margin-bottom: 5px;
  color: #505050;
  font-size: 16px;
  background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
  background: var(--lumiq-bg);
  padding: 2px 5px;
  z-index: 1;
  position: relative;
  display: inline-block;
  cursor: default;
}
`

  const [mobileProceed, setMobileProceed] = useState(false)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [pageState, setPageState] = useContext(PageContext)
  const isEquitas = isEquitasChannel(journeyState?.channel)
  const [agreeTodeclaration, setAgreeToDeclaration] = useState(false)
  const [otpEntered, setOtpEntered] = useState(null)
  const [otpSent, setOtpSent] = useState(false)
  const [registeredMobileNumber, SetRegisteredMobileNumber] = useState(null)
  const [registeredEmailId, SetRegisteredEmailId] = useState(null)
  const [showResendOtpButton, setShowResentOtpButton] = useState(false)
  const [resetOtpCounter, setResetOtpCounter] = useState(0)
  const [placeEntered, setPlaceEntered] = useState();
  const [placeError, setPlaceError] = useState("")
  const [isLaAndPropSame, setIsLaAndPropSame] = useState(null)
  const [isLaMinor, setIsLaMinor] = useState(false)
  const [journeyData, setJourneyData] = useState()
  const [showSpDetailsModal, setShowSpDetailsModal] = useState(false)

  const isSpDetailsMissing = () => !registeredMobileNumber || !registeredEmailId

  const [questions, setQuestions] = useState({ q1: "", q1Details: "", q2: "", q2Details: "", q3: "", q3Details: "", q4: "", q4Details: "" });
  const [questionError, setQuestionError] = useState({})

  let [showError, setShowError] = useState({
    enableAgree: false,
    place: false,
    otp: false,
  })

  useEffect(() => {
    let payload = {
      journeyId: journeyState.journeyId,
    }
    
    async function fetchAndSetJourneyData() {
      try {
        const res = await fetchAllJourneyData(payload);
        let scrOverrideConfig = null;
        if (res?.basicDetails?.channel) {
          try {
            const configResp = await getConfigurationsByType({ type: "scr-override-config" });
            // Get channel in original (e.g., "33") and uppercased (e.g., "AGENCY")
            const channel = res.basicDetails.channel;
            let channelConfig = null;
            if (Array.isArray(configResp?.data)) {
              channelConfig = configResp.data?.[0]?.config?.[channel];
            }
            if (channelConfig) {
              scrOverrideConfig = { config: channelConfig };
            }
          } catch (err) {
            console.log(err);
          }
        }
        if (journeyState?.channel === "36" || res?.basicDetails?.channel === "36") { 
          SetRegisteredMobileNumber(res?.agentDetails?.spPh);
          SetRegisteredEmailId(res?.agentDetails?.spMail);
        } else {
          SetRegisteredMobileNumber(scrOverrideConfig?.config?.spPh || res?.POSdetails?.SPInformation?.mobileNo || res?.agentDetails?.spPh);
          SetRegisteredEmailId(scrOverrideConfig?.config?.spEmail || res?.POSdetails?.SPInformation?.emailId || res?.agentDetails?.spMail);
        }
        setIsLaAndPropSame(res?.lifeAssuredDetails?.isLaAndPropSame);
        if (getAge(res?.lifeAssuredDetails?.dob) < 18) {
          setIsLaMinor(true);
        }
        setJourneyData(res);
      } catch(err) {
        console.log(err);
      }
    }
    fetchAndSetJourneyData();

  }, [])

  useEffect(() => {
    const timer = resetOtpCounter > 0 && setInterval(() => setResetOtpCounter(resetOtpCounter - 1), 1000)
    return () => clearInterval(timer)
  }, [resetOtpCounter])

  useEffect(() => {
    if (!isEquitas || !journeyState.applicationNo) return

    // Trigger SP enrichment on page load for Equitas channel (fire-and-forget)
    triggerSpEnrichment(journeyState.applicationNo)
  }, [isEquitas, journeyState.applicationNo])

  useEffect(() => {
    if (!showSpDetailsModal || !journeyState.applicationNo) return

    return startSpEnrichmentPolling(journeyState.applicationNo, (spData) => {
      SetRegisteredMobileNumber(spData?.SPmobileNumberISNP)
      SetRegisteredEmailId(spData?.SPemailIDISNP)
      setShowSpDetailsModal(false)
    })
  }, [showSpDetailsModal, journeyState.applicationNo])

  const handleAgreeChange = () => {
    setAgreeToDeclaration(prev => !prev)
  }

  const handleInputChange = ({ target }) => {
    if (!isNaN(target.value)) {
      setOtpEntered(target.value)
    } else { }
  }

  const handlePlaceChange = ({ target }) => {
    if (target.value) {
      setShowError(prev => {
        return {
          ...prev,
          place: false
        }
      })
      setPlaceEntered(wordCapital(target.value));
      let pattern = /[\<\>\[\]\{\}\^\?]/
      let n = pattern.test(target.value.toString())
      if (n) {
        setPlaceError("Please enter valid place")
        setShowError(prev => {
          return {
            ...prev,
            place: true
          }
        })
      } else {
        setPlaceError("")
        setShowError(prev => {
          return {
            ...prev,
            place: false
          }
        })
      }
    } else {
      setPlaceError("Please enter place")
      setShowError(prev => {
        return {
          ...prev,
          place: true
        }
      })
      setPlaceEntered("")
    }
  }

  const handleEnterAccept = (event) => {
    if (event.key == 'Enter') {
      handleAccept(event)
    }

  }

  const handleAccept = (e) => {
    let verifyOtpCall = true;
    e.preventDefault();
    if (isSpDetailsMissing()) {
      setShowSpDetailsModal(true)
      return;
    }
    const isValid = validateQuestions()
    if (!isValid) {
      return;
    }

    if (!otpEntered) {
      errorToastr("Please enter Sales Person OTP")
      verifyOtpCall = false
    }

    if (verifyOtpCall) {

      let otpVerifyPayload

      otpVerifyPayload = {
        "mobileNo": registeredMobileNumber,
        "otp": otpEntered,
        "journeyId": journeyState.journeyId,
        "date": Math.floor((new Date().getTime()) / 1000),
        "place": placeEntered,
        "toCallFinalSubmission": true
      }

      if(journeyData?.posDashboardListingDetails?.canaraPosCaseType === "sendLinktosales"){
        otpVerifyPayload = {
          "mobileNo": registeredMobileNumber,
          "otp": otpEntered,
          "journeyId": journeyState.journeyId,
          "date": Math.floor((new Date().getTime()) / 1000),
          "place": placeEntered,
          "toCallFinalSubmission": false
        }
      }

      verifyDeclarationOtpV2(otpVerifyPayload).then(res => {
        if (res?.data?.status) {
          setMobileProceed(true)
          console.log(res)

          const tempSectionStateData = {
            sectionId: props.sections[props.currentSectionIndex].sectionId,
            sectionData: {
              politicallyExposed: questions.q1,
              politicallyExposedDetails: questions.q1 === "Y" ? questions.q1Details : "",
              personalHabits: questions.q2,
              personalHabitsDetails: questions.q2 === "Y" ? questions.q2Details : "",
              furtherInformation: questions.q3,
              furtherInformationDetails: questions.q3 === "Y" ? questions.q3Details : "",
              relationToProposer: questions.q4,
              relationToProposerDetails: questions.q4 === "Y" ? questions.q4Details : "",
            }
          }


          let LoadPaylod = [
            ...journeyState.journeyData,
            {
              pageId: props.pages[props.currentPageIndex].pageId,
              pageData: [...pageState.pageData, tempSectionStateData],
            },
          ]

          let sendPayload = {
            applicationData: LoadPaylod,
            journeyData: {
              _id: journeyState.journeyId,
              journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
              lastPage: props.currentPageIndex,
              lastSection: props.currentSectionIndex + 1,
              applicationNo: journeyState.applicationNo,
              illustrationNumber: journeyState.illustrationNumber,
              proposalEntryId: journeyState.proposalEntryId,
              lastPageCode: props.pageId,
              planOption: journeyState.planOption,
              lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
              scrFirstPass: true
            },
            posDashboardListingData:{
              scrFirstPass: true,
              resumeLinkValidForCustomer: true,
              sendCaseTo: 'customer'
            }
          }
          setJourneyState(prev => {
            return {
              ...prev,
              proposalFormLink: res?.data?.proposalFormLink,
            }
          })
          if(journeyData?.canaraPosCaseType === "sendLinktosales"){
            resumeLinkForSendCaseToCustomer(sendPayload)
          }
          saveApplication(sendPayload).then(res => {
            props.setCurrentSectionIndex(prev => prev + 1)
          }).catch(err => {
            console.log(err, "err in saveApplication declaration")
          })
        } else {
          errorToastr("Please enter correct OTP")
        }

      }).catch(err => {
        console.log(err, "Please enter correct OTP")
      })
    }

  }


  const handleEnter = (event) => {
    if (event.key == 'Enter') {
      generateOtp(event)
    }
  }

  const handleMobileProceed = (e) => {

    setMobileProceed(true)
  }

  const validateQuestions = () => {
    let isValid = true;
    if (!questions.q1) {
      isValid = false
      setQuestionError(prev => ({ ...prev, q1: true }))
    } else {
      setQuestionError(prev => ({ ...prev, q1: false }))
    }

    if (!questions.q1Details && questions.q1 === "Y") {
      isValid = false
      setQuestionError(prev => ({ ...prev, q1Details: true }))
    } else {
      setQuestionError(prev => ({ ...prev, q1Details: false }))
    }

    if (!questions.q2) {
      isValid = false
      setQuestionError(prev => ({ ...prev, q2: true }))
    } else {
      setQuestionError(prev => ({ ...prev, q2: false }))
    }

    if (!questions.q2Details && questions.q2 === "Y") {
      isValid = false
      setQuestionError(prev => ({ ...prev, q2Details: true }))
    } else {
      setQuestionError(prev => ({ ...prev, q2Details: false }))
    }

    if (!questions.q3) {
      isValid = false
      setQuestionError(prev => ({ ...prev, q3: true }))
    } else {
      setQuestionError(prev => ({ ...prev, q3: false }))
    }

    if (!questions.q3Details && questions.q3 === "Y") {
      isValid = false
      setQuestionError(prev => ({ ...prev, q3Details: true }))
    } else {
      setQuestionError(prev => ({ ...prev, q3Details: false }))
    }

    if (!questions.q4) {
      isValid = false
      setQuestionError(prev => ({ ...prev, q4: true }))
    } else {
      setQuestionError(prev => ({ ...prev, q4: false }))
    }

    if (!questions.q4Details && questions.q4 === "Y") {
      isValid = false
      setQuestionError(prev => ({ ...prev, q4Details: true }))
    } else {
      setQuestionError(prev => ({ ...prev, q4Details: false }))
    }

    return isValid
  }

  const generateOtp = (e) => {
    console.log(agreeTodeclaration + "------" + placeEntered);
    e.preventDefault();

    if (isSpDetailsMissing()) {
      setShowSpDetailsModal(true)
      return;
    }

    const isValid = validateQuestions()

    console.info("payload", questions)

    if (!isValid) {
      return;
    }

    if (agreeTodeclaration) {
      setShowError(prev => {
        return {
          ...prev,
          enableAgree: false
        }
      })
    } else {
      setShowError(prev => {
        return {
          ...prev,
          enableAgree: true
        }
      })
    }
    if (placeEntered) {
      if (placeError) {
        setShowError(prev => {
          return {
            ...prev,
            place: true
          }
        })
      } else {
        setShowError(prev => {
          return {
            ...prev,
            place: false
          }
        })
      }
    } else {
      setShowError(prev => {
        return {
          ...prev,
          place: true
        }
      })
    }
    if (registeredMobileNumber && placeEntered && !placeError) {
      let payloadForOtp = {
        mobileNumber: registeredMobileNumber,
        module: "OTPSPEMAIL",
        journeyId: journeyState.journeyId,
        emailID: registeredEmailId,
        "date": Math.floor((new Date().getTime()) / 1000),
        "place": placeEntered,
        sendOtpOnMessagee: true,
        // otpFor: "la"
        pageType : "scrDeclaration"

      }
      setShowResentOtpButton(false)



      const tempSectionStateData = {
        sectionId: props.sections[props.currentSectionIndex].sectionId,
        sectionData: {
          politicallyExposed: questions.q1,
          politicallyExposedDetails: questions.q1 === "Y" ? questions.q1Details : "",
          personalHabits: questions.q2,
          personalHabitsDetails: questions.q2 === "Y" ? questions.q2Details : "",
          furtherInformation: questions.q3,
          furtherInformationDetails: questions.q3 === "Y" ? questions.q3Details : "",
          relationToProposer: questions.q4,
          relationToProposerDetails: questions.q4 === "Y" ? questions.q4Details : "",
        }
      }


      let LoadPaylod = [
        ...journeyState.journeyData,
        {
          pageId: props.pages[props.currentPageIndex].pageId,
          pageData: [...pageState.pageData, tempSectionStateData],
        },
      ]

      let sendPayload = {
        applicationData: LoadPaylod,
        journeyData: {
          _id: journeyState.journeyId,
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          planOption: journeyState.planOption,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        },
      }
      saveApplication(sendPayload).then(res => {
        getOTP(payloadForOtp).then(res2 => {
          
          setOtpSent(true)
          console.log(res2)
          setResetOtpCounter(30)
          setTimeout(() => {
            setShowResentOtpButton(true)
          }, 30000)
        })
      }).catch(err => {
        console.log(err, "err in saveApplication declaration")
      })
    }
  }

  const generateOtp2 = (e) => {
    console.log(agreeTodeclaration + "------" + placeEntered);
    e.preventDefault();
    if (agreeTodeclaration) {
      setShowError(prev => {
        return {
          ...prev,
          enableAgree: false
        }
      })
    } else {
      setShowError(prev => {
        return {
          ...prev,
          enableAgree: true
        }
      })
    }
    if (placeEntered) {
      setShowError(prev => {
        return {
          ...prev,
          place: false
        }
      })
    } else {
      setShowError(prev => {
        return {
          ...prev,
          place: true
        }
      })
    }
  }

  const optionYesNo = [
    { value: "Y", label: "Yes" },
    { value: "N", label: "No" },
  ]

  const handleQuestion = (option, key) => {
    if (option.value) {
      setQuestions(prev => ({ ...prev, [key]: option.value }))
      setQuestionError(prev => ({ ...prev, [key]: false }))
    } else {
      setQuestions(prev => ({ ...prev, [key]: option.value }))
      setQuestionError(prev => ({ ...prev, [key]: true }))
    }
  }

  const handleQuestionDetails = (event, key) => {
    event.preventDefault()
    handleQuestion(event.target, key)
  }

  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }


  return (
    <>
      <style>{

        `
        .mt-25 {
          margin-top: 25px;
        }
        .z-400 {
          z-index: 400 !important;
        }
          @media (max-width:767px){
            .mobile-otp-icon{
              margin-bottom:15px !important;
              display: flex !important;
              justify-content: space-around !important;
            }
            .otp-mobile-view-structure {
              padding:10px 20px !important;
              bottom:40px !important;
            }
            .form-group-PRO{
              margin-bottom:25px !important;
            }
            .form-group-LA{
              margin-bottom:25px !important;
            }
            .otp-mobile-view-structure .sent-otp{
              margin-top:-20px !important;
            }
            .pd-mobile-space-structure {
              padding: 6px 0px;
              padding-bottom: 6px;
            }
            .sent-otp {
              padding: 6px 0 !important;
              font-size: 10px !important;
            }
          }

          @media (max-width:280px){
            .white1 {
              font-size: 14px !important;
              padding: 3px 19px !important;
            }
          }
        `
      }
      </style>
      <form
        autoComplete="off"
        id="calculatePremium"
        name="calculatePremium"
        action=""
        className={isEquitas ? "sales-confidential-report-container" : ""}
      >
        <div className="landing-page1-design">
          <div className="container">
            <div className="iselect-box-design">
              <div className="heading-design">
                <div className="iselect-padding left-side-head ckyc-w">
                  <h1 className="iselect-heading">
                    Sales Confidential Report
                  </h1>
                </div>
                <div className="app-quatation mt">
                  <div className="application-design-number hidden-desktop-screen">
                    Application Number: {journeyState.applicationNo}
                  </div>
                </div>
              </div>
              <div className="iselect-padding">
                {/* <div className="row mb-10 gap-1"> */}

                <div className="row mb-10 gap-5 iselect-mg-bottom-1 enter-otp-structure scr-questions-fixes">
                  <div className="col-md-9 col-xs-12 all-box-padding-right">
                    <SelectContainer channel={journeyState.channel} className={`input-container`} >
                      <label className="input-label scr-label" >
                        Is the Proposer/Life to be assured/ Premium Payer, Politically Exposed Person?
                        {isEquitas && <span className="equitas-required-marker"> *</span>}
                      </label>
                      <Select
                        options={optionYesNo}
                        name="question1"
                        key="Select"
                        id="InputSelect"
                        required={true}
                        isSearchable={false}
                        value={getKeyByValue(optionYesNo, questions.q1)}
                        onChange={(option) => handleQuestion(option, "q1")}
                      />
                    </SelectContainer>
                    {questionError?.q1 ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >Please select is the Proposer/Life to be assured/ Premium Payer, Politically Exposed Person</span>) : (<div className="input-error remove-font-weight"></div>)}
                    {questions.q1 === "Y" && <div className="iselect-mg-bottom-2 enter-otp-structure">
                      <div className="col-md-6 col-xs-12 all-box-padding-right">
                        <div className="form-group">
                          <label className="title-bg inp-label z-400">If yes, provide details{isEquitas && <span className="equitas-required-marker"> *</span>}</label>
                          <input className="form-control" name="question1Details"
                            style={isIE ? { lineHeight: 1 } : {}}
                            type="text" placeholder="Enter Details" maxLength={500} value={questions.q1Details} onChange={(event) => handleQuestionDetails(event, "q1Details")} />
                          {questionError?.q1Details ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >Please enter details</span>) : (<div className="input-error remove-font-weight"></div>)}
                        </div>
                      </div>
                    </div>}
                  </div>
                  <div className="col-md-9 col-xs-12 all-box-padding-right">
                    <SelectContainer channel={journeyState.channel} className={`input-container`} >
                      <label className="input-label scr-label" >
                        Do you notice any adverse health conditions (physical/mental) or personal habits?
                        {isEquitas && <span className="equitas-required-marker"> *</span>}
                      </label>
                      <Select
                        options={optionYesNo}
                        name="Select"
                        key="Select"
                        id="InputSelect"
                        required={true}
                        isSearchable={false}
                        value={getKeyByValue(optionYesNo, questions.q2)}
                        onChange={(option) => handleQuestion(option, "q2")}
                      />
                    </SelectContainer>
                    {questionError.q2 ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >Please select do you notice any adverse health conditions (physical/mental) or personal habits </span>) : (<div className="input-error remove-font-weight"></div>)}
                    {questions.q2 === "Y" && <div className="iselect-mg-bottom-2 enter-otp-structure">
                      <div className="col-md-6 col-xs-12 all-box-padding-right">
                        <div className="form-group">
                          <label className="title-bg inp-label z-400">If yes, provide details{isEquitas && <span className="equitas-required-marker"> *</span>}</label>
                          <input className="form-control" name={+Date.now()}
                            style={isIE ? { lineHeight: 1 } : {}}
                            type="text" placeholder="Enter Details" maxLength={500} value={questions.q2Details} onChange={(event) => handleQuestionDetails(event, "q2Details")} />
                          {questionError.q2Details ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >Please enter details</span>) : (<div className="input-error remove-font-weight"></div>)}
                        </div>
                      </div>
                    </div>}
                  </div>
                  <div className="col-md-9 col-xs-12 all-box-padding-right">
                    <SelectContainer channel={journeyState.channel} className={`input-container`} >
                      <label className="input-label scr-label" >
                        Do you have any relation to Proposer / Life to be assured or taking insurance for himself?
                        {isEquitas && <span className="equitas-required-marker"> *</span>}
                      </label>
                      <Select
                        options={optionYesNo}
                        name="Select"
                        key="Select"
                        id="InputSelect"
                        required={true}
                        isSearchable={false}
                        value={getKeyByValue(optionYesNo, questions.q4)}
                        onChange={(option) => handleQuestion(option, "q4")}
                      />
                    </SelectContainer>
                    {questionError.q4 ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >Please select do you have any relation to Proposer / Life to be assured or taking insurance for himself</span>) : (<div className="input-error remove-font-weight"></div>)}
                    {questions.q4 === "Y" && <div className="iselect-mg-bottom-2 enter-otp-structure">
                      <div className="col-md-6 col-xs-12 all-box-padding-right">
                        <div className="form-group">
                          <label className="title-bg inp-label z-400">If yes, provide details{isEquitas && <span className="equitas-required-marker"> *</span>}</label>
                          <input className="form-control" name={+Date.now()}
                            style={isIE ? { lineHeight: 1 } : {}}
                            type="text" placeholder="Enter Details" maxLength={500} value={questions.q4Details} onChange={(event) => handleQuestionDetails(event, "q4Details")} />
                          {questionError.q4Details ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >Please enter details</span>) : (<div className="input-error remove-font-weight"></div>)}
                        </div>
                      </div>
                    </div>}
                  </div>
                  <div className="col-md-9 col-xs-12 all-box-padding-right">
                    <SelectContainer channel={journeyState.channel} className={`input-container`} >
                      <label className="input-label scr-label" >
                        Do you wish to provide any further information regarding the Proposer and/or Life to be assured?
                        {isEquitas && <span className="equitas-required-marker"> *</span>}
                      </label>
                      <Select
                        options={optionYesNo}
                        name="Select"
                        key="Select"
                        id="InputSelect"
                        required={true}
                        isSearchable={false}
                        value={getKeyByValue(optionYesNo, questions.q3)}
                        onChange={(option) => handleQuestion(option, "q3")}
                      />
                    </SelectContainer>
                    {questionError?.q3 ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >Please select do you wish to provide any further information regarding the Proposer and/or Life to be assured</span>) : (<div className="input-error remove-font-weight"></div>)}
                    {questions.q3 === "Y" && <div className="iselect-mg-bottom-2 enter-otp-structure">
                      <div className="col-md-6 col-xs-12 all-box-padding-right">
                        <div className="form-group">
                          <label className="title-bg inp-label z-400">If yes, provide details{isEquitas && <span className="equitas-required-marker"> *</span>}</label>
                          <input className="form-control" name={+Date.now()}
                            style={isIE ? { lineHeight: 1 } : {}}
                            type="text" placeholder="Enter Details" maxLength={500} value={questions.q3Details} onChange={(event) => handleQuestionDetails(event, "q3Details")} />
                          {questionError?.q3Details ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >Please enter details</span>) : (<div className="input-error remove-font-weight"></div>)}
                        </div>
                      </div>
                    </div>}
                  </div>
                </div>
                <div className="iselect-mg-bottom">
                  <div className="col-md-12 pl-pr">
                    <div className="discloser iselect-box-design">
                      <h2>Declaration by Sales Person:</h2>
                      <ol>
                        <li>
                          I have personally met the Life to be assured. I am satisfied with the identity of the Proposer and/or Life to be Assured (where different) or Premium Payer (where different) and verified the completeness of the documents submitted including age proof, income proof, address proof, AML requirements and any other requirements as applicable.
                        </li>
                        <li>
                          I confirm having explained the complete details of the product selected by the customer/Proposer after undergoing customized Financial Need Assessment and there is no compulsion/forced selling in soliciting the Proposal.
                        </li>
                        <li>
                          I confirm that I have clearly explained to the Proposer, the importance of paying all due premiums on time and the impact of opting for early surrender.
                        </li>
                        <li>
                          I confirm that the statements in this sales confidential report are true and correct to the best of my knowledge and belief and I confirm that the code of conduct, relevant process and regulations have been complied with.
                        </li>
                        <li>
                          I certify and ratify to the Company that all KYC documents/Tax related information are personally seen and verified by me in original and I have taken the scanned images of the documents and uploaded the same.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>

                {/* </div> */}
                <div className="mg-bottom pd40">
                  <div className="col-md-12 col-xs-12 pl">
                    <div className="transactionDetailsWrap del-agree">
                      <div className="detailContentWrap">
                        <div className="row iAgree">
                          <div className="form-group">
                            <div className="inner-addon left-addon">
                              <div className="checkbox1">
                                <input
                                  name="checkboxG6"
                                  id="checkboxG6"
                                  className="css-checkbox"
                                  type="checkbox"
                                  onChange={handleAgreeChange}
                                  checked={agreeTodeclaration}
                                />
                                <label
                                  htmlFor="checkboxG6"
                                  className="css-label"
                                >
                                  {" "}
                                  I agree to the Declaration and Authorization
                                  as mentioned above.
                                </label>
                              </div>
                              {showError && showError.enableAgree ? (<div style={{ color: "red" }}>*This field is required</div>) : (<div></div>)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="date-and-place-structure row">
                  <div className="col-md-4" style={{ top: "18px" }} >
                    <p className="ml-10">
                      <span>Date: </span>{getDateInFormat(Math.floor((new Date().getTime()) / 1000))}
                    </p>
                  </div>
                  <div className="col-md-6" style={{ top: "-40px" }} >
                    <p>
                      {" "}
                      {/* <span>Place:</span>  */}
                      <div className="iselect-mg-bottom-1 enter-otp-structure">
                        <div className="col-md-6 col-xs-12 all-box-padding-right">
                          <div className="form-group">
                            <label className="title-bg inp-label">Place{isEquitas && <span className="equitas-required-marker"> *</span>}</label>
                            <input className="form-control" name={+Date.now()}
                              style={isIE ? { lineHeight: 1 } : {}}
                              type="text" placeholder="Enter place" value={placeEntered} autoComplete="new-password" onChange={handlePlaceChange} />
                            {showError && showError.place ? (<span style={{ color: "red" }} className="input-error remove-font-weight" >{placeError}</span>) : (<div></div>)}
                          </div>
                        </div>
                      </div>
                    </p>
                  </div>
                </div>
                <div className="clearfix"></div>
                {/* {isLaAndPropSame === "N" &&
                  <div className="generate-otp-structure hidden-desktop-screen" style={{ marginTop: "0" }} >
                    <div className="previous-btn cen button" tabIndex="0" onKeyPress={(event) => { handleEnter2(event) }} style={{
                      transition: "none",
                      padding: "0",
                      backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}`
                    }}> 
                      {!otpSent2 &&
                        <button className="white1" onClick={generateOtp2} style={{ border: "none", color: "white", borderRadius: "1rem", outline: "none", width: "auto", fontSize: "16px", padding: "6px 40px", backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}` }} disabled={!agreeTodeclaration}>
                          Generate OTP
                        </button>
                      }
                    </div>
                    {otpSent2 &&
                      <p className="sent-otp">
                        {" "}
                        OTP has been sent to your registered mobile number and email id
                      </p>
                    }
                  </div>} */}
                <div className="clearfix"></div>
                {/* {isLaAndPropSame === "N" &&
                  <div className="iselect-mg-bottom mt-30 enter-otp-structure hidden-desktop-screen" style={{ "paddingBottom": "20px" }}>
                    <div className="col-md-6 col-xs-12 all-box-padding-right">
                      <div className="form-group">
                        <label className="title-bg inp-label z-0">Enter OTP TO PROPOSER</label>
                        <input
                          className="form-control"
                          style={isIE ? { lineHeight: 1 } : {}}
                          name="otp"
                          type="text"
                          autoComplete="new-password"
                          placeholder="XXXXXX"
                          onChange={handleInputChange2}
                          maxLength={6}
                          value={otpEntered2}
                        />
                        {showResendOtpButton2 ?
                          <div className="resend-otp">
                            <a tabIndex="0" onKeyPress={(event) => { handleEnter2(event) }} onClick={generateOtp2}>RESEND OTP</a>{" "}
                            <span className="fa fa-angle-right"></span>
                          </div>
                          : (otpSent2 &&
                            <div className="resend-otp">
                              <span className="fa">RESEND OTP In {resetOtpCounter2} seconds</span>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>} */}
                <div className="clearfix"></div>
                {!isLaMinor &&
                  <div className="generate-otp-structure" style={{ marginTop: "0" }} >
                    <div className="previous-btn cen button" tabIndex="0" onKeyPress={(event) => { handleEnter(event) }} style={{
                      transition: "none",
                      padding: "0",
                      backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}`
                    }}>
                      {!otpSent &&
                        <button className="white1" onClick={generateOtp} style={{ border: "none", color: "white", borderRadius: "1rem", outline: "none", width: "auto", fontSize: "16px", padding: "6px 40px", backgroundColor: `${agreeTodeclaration ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}` }} disabled={!agreeTodeclaration}>
                          Generate OTP
                        </button>
                      }
                    </div>
                    {otpSent &&
                      <p className="sent-otp">
                        {" "}
                        OTP has been sent to your registered mobile number and email id
                      </p>
                    }
                  </div>
                  }
                <div className="clearfix"></div>
                {!isLaMinor &&
                  <div className="iselect-mg-bottom mt-30 enter-otp-structure">
                    <div className="col-md-6 col-xs-12 all-box-padding-right">
                      <div className="form-group">
                        <label className="title-bg inp-label">Enter OTP To Sales Person{isEquitas && <span className="equitas-required-marker"> *</span>}</label>
                        <input
                          className="form-control"
                          style={isIE ? { lineHeight: 1 } : {}}
                          name="otp"
                          type="text"
                          autoComplete="new-password"
                          placeholder="XXXXXX"
                          onChange={handleInputChange}
                          maxLength={6}
                          value={otpEntered}
                        />
                        {showResendOtpButton ?
                          <div className="resend-otp">
                            <a tabIndex="0" onKeyPress={(event) => { handleEnter(event) }} onClick={generateOtp}>RESEND OTP</a>{" "}
                            <span className="fa fa-angle-right"></span>
                          </div>
                          : (otpSent &&
                            <div className="resend-otp">
                              <span className="fa">RESEND OTP In {resetOtpCounter} seconds</span>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>}
                <div className="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                  <div className="col-md-12">
                    <div className="but-center text-center">
                      {/* <div className="submit-btn cen">
                        {" "}
                        <a>Previous</a>{" "}
                      </div> */}
                      <div className="previous-btn cen" onKeyPress={(event) => { handleEnterAccept(event) }} tabIndex="0"
                      // style={{backgroundColor: `${otpEntered?.length === 6 ? (journeyState.channel === "A" ? "#db0011" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#fec32b" : "#eb7f25") : "grey"}`}}
                      > {/*var(--lumiq-tertiary);*/}
                        <button
                          type="submit"
                          value="accept"
                          style={{
                            backgroundColor: "transparent",

                            padding: "0px 45px",
                            border: "none",
                            color: "#fff",
                            height: "25px",
                            width: "100%",
                            fontSize: "16px"
                          }}
                          // disabled={otpEntered?.length !== 6}
                          onClick={handleAccept}
                        >
                          Accept
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* body Section */}
        {/* mobile view otp screen */}
        <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
          <div className="iselect-mg-bottom">
            <div className="col-md-12">
              <div className="but-center text-center">
                <div className="previous-btn cen">
                  <a>
                    {" "}
                    <button
                      onClick={handleAccept}
                      type="submit"
                      value="button1"
                      style={{ backgroundColor: "transparent", padding: "0px 10px", border: "none", color: "#fff" }}
                    >
                      Proceed
                    </button>{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <ConfirmProceedModal
        show={showSpDetailsModal}
        title="SP Details Unavailable"
        onOk={() => setShowSpDetailsModal(false)}
        onClose={() => setShowSpDetailsModal(false)}
        message="Cannot proceed further. SP Mobile number/Email ID not valid or missing."
        okText="OK"
      />
    </>
  )
}

export default SalesConfidentialReport